/* Progressive enhancement only: navigation and forms work without JavaScript. */
(() => {
  'use strict';
  document.querySelectorAll('[data-sa-language]').forEach(select => {
    const button = select.form && select.form.querySelector('.sa-language-submit');
    if (button) button.hidden = true;
    select.addEventListener('change', () => { if (select.form) select.form.requestSubmit(); });
  });
  document.querySelectorAll('[data-sa-menu]').forEach(menu => {
    const summary = menu.querySelector('summary');
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) { menu.open = false; summary.focus(); }
    });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
    document.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
  });
  const current = new URL(window.location.href);
  document.querySelectorAll('.sa-desktop-nav a').forEach(link => {
    const target = new URL(link.href, current.origin);
    if (target.pathname === current.pathname && target.searchParams.get('view') === current.searchParams.get('view')) link.setAttribute('aria-current', 'page');
  });

  const track = (eventName, detail = {}) => {
    const payload = { event: eventName, ...detail };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('solutello:track', { detail: payload }));
  };

  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'msclkid'];
  const params = new URLSearchParams(window.location.search);
  let landingPage = `${window.location.pathname}${window.location.search}`;
  let referrer = document.referrer || '';
  try {
    attributionKeys.forEach(key => {
      const value = params.get(key);
      if (value) sessionStorage.setItem(`sa_attribution_${key}`, value);
    });
    if (!sessionStorage.getItem('sa_landing_page')) sessionStorage.setItem('sa_landing_page', landingPage);
    if (!sessionStorage.getItem('sa_referrer') && referrer) sessionStorage.setItem('sa_referrer', referrer);
    landingPage = sessionStorage.getItem('sa_landing_page') || landingPage;
    referrer = sessionStorage.getItem('sa_referrer') || referrer;
  } catch (error) {
    /* Storage can be unavailable in strict privacy contexts. Current-page attribution still works. */
  }

  document.querySelectorAll('[data-sa-attribution]').forEach(field => {
    const key = field.getAttribute('data-sa-attribution');
    let value = '';
    if (key === 'landing_page') value = landingPage;
    else if (key === 'referrer') value = referrer;
    else {
      value = params.get(key) || '';
      if (!value) {
        try { value = sessionStorage.getItem(`sa_attribution_${key}`) || ''; } catch (error) { /* no-op */ }
      }
    }
    field.value = value;
  });

  document.querySelectorAll('[data-sa-track]').forEach(element => {
    element.addEventListener('click', () => {
      track(element.getAttribute('data-sa-track'), {
        page_path: window.location.pathname,
        destination: element.getAttribute('href') || ''
      });
    });
  });

  document.querySelectorAll('.sa-contact-form').forEach(form => {
    form.addEventListener('submit', () => {
      track('lead_form_submit', { form_name: 'solutello_contact', page_path: window.location.pathname });
    });
  });

  if (document.querySelector('[data-sa-form-success]')) {
    track('generate_lead', { form_name: 'solutello_contact', page_path: window.location.pathname });
  }
})();
